<template>
  <div>
    <van-popup v-model="guize" :close-on-click-overlay="false">
      <div class="wrapper guize" id="guizetankuang">
        <div class="block" style="width: 6rem; margin: 0 auto 0.6rem">
          <h1>活动规则</h1>
          <p class="ql-editor" v-html="goodsBargain.rule" style="min-height:3rem;max-height:5rem;overflow-y: auto;"></p>
        </div>
        <img
          src="../img/close.png"
          style="width: 0.6rem"
          id="guizeguanbi"
          @click="get('guize')"
        />
      </div>
    </van-popup>

    <van-popup v-model="fenxiang" :close-on-click-overlay="false">
      <div class="wrapper fenxiang" id="fenxianghaibao">
        <div class="block blockBg">
          <img
            src="../img/ico_close2.png"
            style="width: 0.6rem; position: absolute; right: 3%; top: 2%"
            @click="get('fenxiang')"
          />
          <div class="box">
            <img
              :src="goodsBargain.helpImg"
              alt=""
              style="width: 4.9rem; height: 2.4rem"
            />
            <div class="code">
              <vue-qr
                :text="shareUrl"
                :margin="0"
                colorDark="#000"
                colorLight="#fff"
                logoSrc=""
                :logoScale="0.2"
                :size="200"
              ></vue-qr>
              <p>微信扫码，帮我砍一刀</p>
            </div>
            <a class="btn flex" id="fenxianghaibao">
              <img src="../img/down.png" alt="" style="width: 0.4rem" />&nbsp;
            长按保存图片
              <img class="img_url" :src="saveImg"/>
            </a>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="fenxiang"
      :close-on-click-overlay="false"
      :overlay="false"
      class="fenxiangtishi"
    >
      <div class="wrapper fenxiang">
        <img
          :src="goodsBargain.wechatAmount >0?require('../img/ico_fenxiang.png'):require('../img/ico_fenxiang2.png')"
          style="width: 5rem; margin-right: -1rem"
        />
      </div>
    </van-popup>

    

    <van-overlay :show="xitongkanjia" ref="progress" z-index="2008">
      <div class="wrapper kanjia" id="xitongkanjia">
        <div class="block" style="border-radius: 0.28rem;width:5rem;">
          <div class="topImg" style="margin-top: -0.6rem">
            <img src="../img/xitong.png" />
          </div>
          <div class="tit">药联健康</div>
          <div class="info">
            帮您砍掉&nbsp;<span style="font-family: HelveticaNeue-Medium, HelveticaNeue;">{{kanjiaInfo.systemAmount}}</span>&nbsp;元，已砍至&nbsp;<span>{{kanjiaInfo.currentPrice}}</span>&nbsp;元
          </div>
          <div class="progress">
            <van-progress
              color="linear-gradient(135deg, #FFA000 0%, #FF6600 100%)"
              track-color="#FFEEED"
              :show-pivot="false"
              stroke-width="14px"
              :percentage="kanjiaInfo.percentage"
              style="border-radius: 14px"
              v-if="xitongkanjia"
            />
            <div class="jindu">
              <span>原价&nbsp;<i style="font-style: normal;font-family: PingFangSC-Medium, PingFang SC;">¥{{goodsBargain.salePrice}}</i></span>
              <span>可砍至&nbsp;<i style="font-style: normal;font-family: PingFangSC-Medium, PingFang SC;">¥{{goodsBargain.minPrice}}</i></span>
            </div>
          </div>
          <div class="btn" id="fenxiangqun" @click="fenxiang11('fenxiangqun')" v-if="kanjiaInfo.wechatAmount != 0">
            <a class="flex"
              ><img
                src="../img/ico_wx.png"
                alt=""
                style="width: 0.4rem"
              />&nbsp;分享至微信群，再砍{{kanjiaInfo.wechatAmount}}元</a
            >
          </div>
          <div class="btn" v-if="kanjiaInfo.wechatAmount == 0" @click="fenxiang11('fenxianghaoyou')">
            <a class="flex"
              ><img
                src="../img/ico_wx.png"
                alt=""
                style="width: 0.4rem"
              />&nbsp;分享好友，再砍一刀</a
            >
          </div>
        </div>
        <img
          src="../img/close.png"
          style="width: 0.6rem"
          @click="get('xitongkanjia')"
        />
      </div>
    </van-overlay>

    
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import vueQr from "vue-qr";
export default {
  props: {
    type: String,
    goodsBargain:Object,
    kanjiaInfo:Object,
    kanjiaType:String,
    info: Object,
    saveImg:String,
    shareUrl:String
  },
  components: {
    vueQr
  },
  data() {
    return {
      guize: false,
      xitongkanjia: false,
      fenxiangkanjia: false,
      fenxiang: false,
      img_url: "",
      base64:"",
      skuNo:"",
      nokan:true,
      anniu:"",
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    };
  },
  watch: {
    type(n, o) {
      //n为新值,o为旧值;
      console.log("watch-n", n);
      // alert(n)
      if (n == "guize") this.guize = true;
      if (n === "xitongkanjia") this.xitongkanjia = true;
      if (n === "fenxiangkanjia") this.fenxiangkanjia = true;
      if (n == "fenxiang"||n == "fenxiang2") this.fenxiang = true;
      if(!n){
        this.fenxiang = false;
      }
      if(n == 'fenxiang'){
        let { sellType,sellLabel,channel } = this.$route.query;
        this.$trackFn.send("click_material", {
            page_type: "good_detailh5",
            page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
            item_id:this.info.skuNo,
            item_type:"product_id",
            card_type: "bargain_poster",
            sell_type:sellType,
            sell_label:sellLabel,
            sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
            material_type:"poster"
          });
      }
    },
  },
  created () {
    console.log(this.goodsBargain)
    this.skuNo = this.$route.query.skuNo;
  },
  mounted() {
    // this.get_img();
  },
  methods: {
    get(type) {
      this.guize = false;
      this.xitongkanjia = false;
      this.fenxiangkanjia = false;
      this.fenxiang = false;
      if (this.nokan) {
        this.$emit("dateFn", type);
      }else{
        this.$emit("dateFn", 'gengxin');
      }
    },
    fenxiang11(event){
      this.xitongkanjia = false;
      this.fenxiangkanjia = false;
      this.anniu = event
      this.type = "fenxiang"
      if(event == 'fenxiangqun'){
         this.$emit("dateFn",'gengxin')
      }
      if(event == 'fenxianghaoyou'){
         this.nokan = false
         this.$emit("dateFn",'fenxiangtankuang')
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  .block {
    margin: 0 0.8rem 0.6rem;
    padding: 0 0.48rem 0.42rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.2rem;
  }
  @media (min-device-width: 320px) and(max-device-width:414px) and(-webkit-min-device-pixel-ratio:2) {
    .block {
      margin-top: 1rem;
    }
  }
}
.guize {
  h1 {
    font-size: 0.36rem;
    color: #3a3a3a;
    padding: 0.4rem 0 0.3rem;
    text-align: center;
  }
  p {
    font-size: 0.28rem;
    color: #535353;
    // padding-bottom: 0.2rem;
  }
}
.fenxiang {
  width: 6rem;
  text-align: center;
  .block {
    width: 5rem;
    margin: 0.8rem auto 0;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
  }
  .tit {
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    word-break: keep-all;
    padding-bottom: 0.4rem;

font-family: PingFangSC-Medium, PingFang SC;
  }
  .code {
    padding: 0.4rem 0;
    img{
      width: 2rem;
    }
    p {
      font-size: 30px;
      font-weight: 500;
      color: #333333;
      padding-top: 0.2rem;
    }
  }
  .btn {
    font-size: 32px;
    padding: 24px 0;
    background: linear-gradient(128deg, #f26b57 0%, #dd2b1e 100%);
    box-shadow: 0px 8px 16px 0px rgba(224, 32, 32, 0.3);
    border-radius: 16px;
    color: #fff;
  }
  .blockBg {
    position: relative;
    // height: 8rem;
    background: url("../img/changan1.png") center no-repeat;
    background-size: 100% 100%;
    .box {
      margin-top: 1.4rem;
    }
  }
  .img_url {
    width: 100%;
    height: 1rem;
    opacity: 0;
    position: absolute;
    left: 0;
    bottom: 6%;
  }
}
.kanjia {
  .tit {
    padding: 0.4rem 0 0;
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    text-align: center;
  }
  .info {
    color: #333333;
    text-align: center;
    padding-top: 0.6rem;
    padding-bottom: 0.4rem;
    word-break: keep-all;
    span {
      color: #ff5d5d;

      font-weight: 500;
    }
    span:first-child {
      font-size: 48px;
    }
  }
  .progress {
    ::v-deeep.van-progress {
      border-radius: 14px;
    }
    .jindu {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      color: #666666;
    }
  }
  .btn {
    padding: 60px 0 30px;
    a {
      background: linear-gradient(135deg, #ffa000 0%, #ff6600 100%);
      box-shadow: 0px 8px 12px 0px rgba(255, 117, 0, 0.2);
      font-size: 32px;
      color: #fff;
      border-radius: 16px;
      padding: 28px 0;

font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .topImg {
    // margin-top: -1.2rem;
    width: 120px;
    height: 120px;
    box-shadow: 0px 4px 12px 0px rgba(91, 91, 91, 0.1);
    border: 3px solid #ffffff;
    margin: auto;
    border-radius: 50%;
  }
  .topImg2 {
    text-align: center;
  }
  .friends {
    padding-top: 0.4rem;
    text-align: center;
    .tou {
      line-height: 1;
      padding-bottom: 20px;
      img {
        width: 50px;
        height: 50px;
        margin-left: -10px;
        border-radius: 50%;
      }
      &:first-child {
        margin-left: 0;
      }
    }
    .name {
      font-size: 28px;
      font-weight: 500;
      color: #333333;
    }
  }
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fenxiangtishi {
  left: 56% !important;
  top: 5% !important;
}

</style>
